var _style, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "BT_Logo",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 788.22 788.44",
    style: {
      enableBackground: "new 0 0 788.22 788.44"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#5514B4;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M406.78,305.29h129.87v38.07H493.1v139.26h-42.77V343.36h-43.55V305.29z M394,622.93 c-126.22,0-228.71-102.49-228.71-228.71S267.78,165.51,394,165.51S622.72,268,622.72,394.22S520.23,622.93,394,622.93 M394,655 c143.95,0,260.79-116.83,260.79-260.79S537.96,133.43,394,133.43c-143.95,0-260.79,116.83-260.79,260.79S250.05,655,394,655  M349.93,428.38c0-11.21-7.04-18.78-19.04-18.78h-28.69v37.03h28.69C342.89,446.64,349.93,439.07,349.93,428.38 M344.72,357.19 c0-9.39-6-15.91-16.17-15.91h-26.34v32.34h26.34C338.72,373.61,344.72,367.1,344.72,357.19 M393.22,430.47 c0,33.64-23.73,52.16-57.63,52.16h-75.58V305.29h70.63c34.16,0,57.37,17.47,57.37,49.55c0,14.6-6.52,27.64-16.95,35.47 C383.05,397.35,393.22,410.91,393.22,430.47"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.6a917882464eca1dfb72932e44e97ba4.svg";
export { ForwardRef as ReactComponent };